// Every attached tray uses the XP strip as the player dock's upper edge.
// DM docks without a strip keep their existing anchor.
export function getHudDockTop(dock) {
  const top = dock.getBoundingClientRect().top;
  const strip = dock.querySelector('.experience-track');
  return top - (strip ? strip.getBoundingClientRect().height || 16 : 0);
}
